import * as React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import Select from 'react-select'

import media from '../../../services/generateMediaQueries'

const ComponentBase = styled.div`
  margin-bottom: 0.625rem;
`

const ControlBase = styled.label`
  position: relative;
  display: block;
  width: 100%;
  min-height: 3.5rem;
  height: auto;
  padding-top: 0.5rem;
  padding-bottom: 0.25rem;
  font-size: 1rem;
`

const Placeholder = styled.span`
  display: flex;
  align-items: center;
  padding: 0 0.25rem;
  color: var(--color-fg-light);
  position: absolute;
  top: 0.5rem;
  height: 3rem;
  left: 1.125rem;
  transition-property: font-size, height, background-color, padding, top;
  transition-duration: var(--animation-duration);
  transition-timing-function: var(--animation-easing);
  &:empty {
    display: none;
  }

  ${props =>
    props.focused &&
    css`
      color: var(--color-primary);
    `}
  
  ${props =>
    props.hasError &&
    (props.hasValue || props.focused) &&
    css`
      color: var(--color-error);
    `}
  
  ${props => {
    if (props.hasValue || props.focused) {
      if (props.floating) {
        return css`
          background-color: var(--color-bg-form);
          height: 1rem;
          padding: 0 0.25rem;
          font-size: 0.75em;
          top: 0;
          left: 0.75rem;
        `
      }
      return css`
        display: none;
      `
    }

    return null
  }}
`

const Control = styled(Select)`
  .custom-dropdown {
    &__control {
      min-height: 48px;
      height: auto;
      background: transparent;
      border: var(--border-form);

      ${media.lessThan('small')`
        min-height: unset;
      `}
    }

    &__value-container {
      padding: 0 1.125rem;
      flex-wrap: wrap;
      row-gap: 0.25rem;
      align-items: center;
    }

    &__value-container--is-multi {
      padding-top: 0.125rem;
      padding-bottom: 0.125rem;
    }

    &__multi-value {
      margin: 0 0.25rem 0 0;
    }
  }
`

function CustomDropdown(props) {
  const {
    placeholder,
    selectPlaceholder = '',
    options = [],
    value,
    onChange,
    onFocus,
    onBlur,
    className,
    isClearable = true,
    ...restProps
  } = props
  const [focused, setFocused] = React.useState(false)

  const hasValue = Array.isArray(value) ? value.length > 0 : value !== ''

  const handleFocus = () => {
    setFocused(true)
    if (onFocus) {
      onFocus()
    }
  }

  const handleBlur = () => {
    setFocused(false)
    if (onBlur) {
      onBlur()
    }
  }

  const handleChange = (option, action) => {
    if (onChange) {
      onChange(option, action)
    }
  }

  return (
    <ComponentBase>
      <ControlBase>
        <Control
          {...restProps}
          isSearchable
          isClearable={isClearable}
          menuPlacement="auto"
          placeholder={selectPlaceholder}
          value={value}
          options={options.sort((a, b) =>
            a.name > b.name ? 1 : a.name < b.name ? -1 : 0,
          )}
          focused={focused}
          className="custom-dropdown-component"
          classNamePrefix="custom-dropdown"
          theme={theme => {
            return {
              ...theme,
              colors: {
                ...theme.colors,
                primary: '#5bbdaf',
                primary25: '#8EF0E2',
                primary50: '#DAFFFF',
                primary75: '#F4FFFF',
              },
            }
          }}
          onChange={handleChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
        <Placeholder
          focused={focused}
          hasValue={hasValue}
          hasError={false}
          floating
        >
          {placeholder}
        </Placeholder>
      </ControlBase>
    </ComponentBase>
  )
}

CustomDropdown.propTypes = {
  options: PropTypes.array,
  selectPlaceholder: PropTypes.string,
}

export default CustomDropdown
